import * as S from './styles';

export const Empty = () => {
  return (
    <S.Empty>
      <S.EmptyIcon />
      <S.EmptyTitle>Nenhum cliente encontrado</S.EmptyTitle>
    </S.Empty>
  );
};